import { Link } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../Button/Button";
import NavbarLinks from "../navbarLinks/NavbarLinks";

type Props = PropsWithChildren<{
  sidebar: boolean;
  toggle: () => void;
}>;

const Sidebar: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation("global");

  return (
    <nav className={`m-sidebar ${props.sidebar ? "m-sidebar--active" : ""}`}>
      <NavbarLinks toggle={props.toggle} />
      <Button
        fromRender={"menu-mobile"}
        arial={"Abre un formulario de contacto"}
      >
        {t("Empezar proyecto")}
      </Button>
    </nav>
  );
};

export default Sidebar;
